import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, useMemo } from 'react';
import styles from '../../../styles.module.scss';
import { AnchorItemKey, PaymentRuleData } from '../../../types';
import { HeaderSection, SingleRow } from '../../Common';
import { SingleRowProps } from '../../type';
import { ExpenseAccrualDateContent, PaymentDueDateContent } from './components';

const cx = classnames.bind(styles);

type PaymentRuleProps = {
  paymentRule?: PaymentRuleData;
};

export const PaymentRule: FC<PaymentRuleProps> = ({ paymentRule }) => {
  const { t } = useTranslation();

  const rows: SingleRowProps[] = useMemo(() => {
    return [
      {
        label: t(
          'ap_payee_detail_drawer_payment_rule_payment_closing_date_label',
          { defaultValue: '費用計上日' }
        ),
        renderContent: (
          <ExpenseAccrualDateContent
            paymentClosingDate={paymentRule?.payment_closing_date}
          />
        ),
      },
      {
        label: t('ap_payee_detail_drawer_payment_rule_payment_due_date_label', {
          defaultValue: '支払期日',
        }),
        renderContent: (
          <PaymentDueDateContent
            paymentDueMonth={paymentRule?.payment_month}
            paymentDueDate={paymentRule?.payment_due_date}
          />
        ),
      },
      {
        label: t(
          'ap_payee_detail_drawer_payment_rule_payment_holiday_rule_label',
          { defaultValue: '支払期日が土日の場合' }
        ),
        value: paymentRule?.payment_holiday_rule,
      },
    ];
  }, [paymentRule, t]);

  return (
    <div
      id={AnchorItemKey.PAYMENT_RULE}
      className={cx('subSectionContainer')}
      key='payment-rule-sub-section-container'
    >
      <HeaderSection
        displayName={t('ap_payee_detail_drawer_payment_rule')}
        isSubHeader
      />
      <div className={cx('bodySectionContainer')}>
        {rows.map((item, index) => (
          <SingleRow
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            renderContent={item.renderContent}
            contentClassName={item.contentClassName}
          />
        ))}
      </div>
    </div>
  );
};

PaymentRule.displayName = 'PaymentRule';
